import { Monitor } from "lucide-react";
import type { GuestTabletDeviceStatus } from "@/types/guestTablet";

type Props = {
  status: GuestTabletDeviceStatus | null;
  loading: boolean;
  error: string | null;
  onRetry: () => void;
};

export function InfoScreenDevicePendingScreen({
  status,
  loading,
  error,
  onRetry,
}: Props) {
  const isRevoked = status?.status === "revoked";

  return (
    <div className="info-screen-device-pending">
      <div className="info-screen-device-pending__card">
        <div className="info-screen-device-pending__icon" aria-hidden>
          <Monitor className="h-7 w-7" strokeWidth={1.75} />
        </div>

        <h1 className="info-screen-device-pending__title">
          {isRevoked ? "Display gesperrt" : "Freischaltung erforderlich"}
        </h1>

        {loading && !status ? (
          <p className="info-screen-device-pending__message">Display wird registriert…</p>
        ) : null}

        {status ? (
          <>
            <p className="info-screen-device-pending__message">{status.message}</p>
            <dl className="info-screen-device-pending__details">
              <div>
                <dt>Anzeigeort</dt>
                <dd>{status.workstation_label}</dd>
              </div>
              <div>
                <dt>Geräte-Kennung</dt>
                <dd>
                  <code className="info-screen-device-pending__code">
                    {status.device_token_short}
                  </code>
                </dd>
              </div>
            </dl>
            {!isRevoked ? (
              <p className="info-screen-device-pending__hint">
                Ein Administrator kann dieses Display unter Stammdaten → Infobildschirm
                freischalten. Die Seite aktualisiert sich automatisch nach der Freigabe.
              </p>
            ) : null}
          </>
        ) : null}

        {error ? (
          <p className="info-screen-device-pending__message mt-4 text-red-600" role="alert">
            {error}
          </p>
        ) : null}

        <button
          type="button"
          className="info-screen-device-pending__retry"
          onClick={() => void onRetry()}
        >
          Erneut versuchen
        </button>
      </div>
    </div>
  );
}
